export const customerClaimsColumns = [
  { key: 'month', text: 'Month', width: '20%' },
  { key: 'amount', text: 'Amount', width: '20%' },
  { key: 'totalNewBalance', text: 'Balance', width: '20%' },
  { key: 'options', text: '', width: '5%' }
];
